import dialogs from "./dialogs.js"
import vlists from "./vlists.js"
import collapses from "./collapses.js"
import toolbar from "./toolbar.js"

export default {
    dialogs,
    collapses,
    vlists,
    toolbar,
    history: vlists.history,
    love: vlists.love,
    extensions: vlists.extensions
}
